<template>
  <div class="home">
    <h1>Welcome to the SeasonCast Streaming Platform</h1>
    <br />
    <p>watch.seasoncast.com is under development. The goal of this project is to replace SeasonCast.com with a dynamic website.</p>
    <a href="https://seasoncast.com">[Go to SeasonCast.com]</a> 
   
  </div>
</template>

<script>


export default {
  name: 'Home',
  components: {
  }
}
</script>
